import { render, staticRenderFns } from "./PersonalGuessrecord.vue?vue&type=template&id=27e3b50d&"
import script from "./PersonalGuessrecord.vue?vue&type=script&lang=js&"
export * from "./PersonalGuessrecord.vue?vue&type=script&lang=js&"
import style0 from "./PersonalGuessrecord.vue?vue&type=style&index=0&id=27e3b50d&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports